import { useState, useEffect } from 'react';

const ADMIN_SESSION_KEY = 'rtb_admin_session';

export interface AdminSession {
  username: string;
  role: string;
  display_name: string;
  role_display_name: string;
  permissions: string[];
}

export function useAdminAuth() {
  const [session, setSession] = useState<AdminSession | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = sessionStorage.getItem(ADMIN_SESSION_KEY);
    if (stored) {
      try {
        setSession(JSON.parse(stored));
      } catch {
        sessionStorage.removeItem(ADMIN_SESSION_KEY);
      }
    }
    setLoading(false);
  }, []);

  const login = (s: AdminSession) => {
    sessionStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(s));
    setSession(s);
  };

  const logout = () => {
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
    setSession(null);
  };

  const hasPermission = (perm: string): boolean => {
    return session?.permissions?.includes(perm) ?? false;
  };

  return { session, loading, login, logout, hasPermission };
}